import { themeStore } from "@/stores/theme";
import { Box, BoxProps, Center, Flex, Text } from "@chakra-ui/react";
import { langStore, translate } from "@noli/business";
import { observer } from "mobx-react-lite";
import { SizeCard } from "../SizeCard";

import { ReactComponent as Size_1_1_Icon } from "@/assets/icons/size_1-1.svg";
import { ReactComponent as Size_3_4_Icon } from "@/assets/icons/size_3-4.svg";
import { ReactComponent as Size_4_3_Icon } from "@/assets/icons/size_4-3.svg";
import { Editor_Words } from "@/utils/lang/editor";

export const SizeSelector = observer(
  ({ showSizeSelectorMessage, ...others }: { showSizeSelectorMessage?: boolean } & BoxProps) => {
    const lang = langStore.tgt;
    const { captionColor, titleColor } = themeStore.styles;

    return (
      <Center>
        <Flex w="100%" alignItems="center" {...others}>
          <Text color={titleColor} fontSize="14px" whiteSpace="nowrap">
            {translate(Editor_Words["txt2img-sd-size-title"], lang)}：
          </Text>
          {showSizeSelectorMessage ? (
            <Center>
              <Text color={captionColor} fontSize="12px">
                {translate(Editor_Words["txt2img-sd-size-message"], lang)}
              </Text>
            </Center>
          ) : (
            <Flex alignItems="center">
              <SizeCard size="1:1" icon={Size_1_1_Icon} />
              <SizeCard size="3:4" icon={Size_3_4_Icon} />
              <SizeCard size="4:3" icon={Size_4_3_Icon} />
            </Flex>
          )}
        </Flex>
      </Center>
    );
  },
);
